/** Заглушки MAX — в Telegram Mini App не используются. */

export async function tryAuthenticateMaxWebApp() {
  return { ok: false, reason: "not_max" };
}

export async function ensureMarketplaceJwtForMaxParticipate() {
  return { ok: false };
}

export function requestMaxWebAppContactPhone() {
  return Promise.reject(new Error("MAX недоступен"));
}
